var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 149,
    viewBox: "0 0 148 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0625,
    cy: 74.3535,
    r: 73.9375,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0609,
    cy: 74.3522,
    r: 62.3392,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2514 101.046C69.3109 101.046 65.2023 100.34 61.9254 98.9283C58.6486 97.4663 56.1784 95.4246 54.5147 92.8031C52.8511 90.1312 52.0193 87.0056 52.0193 83.4263H63.1354C63.1354 84.8379 63.5135 86.1738 64.2696 87.4341C65.0258 88.6441 66.2357 89.6271 67.8994 90.3833C69.563 91.0891 71.6803 91.442 74.2514 91.442C77.6795 91.442 80.301 90.837 82.1158 89.6271C83.9811 88.4172 84.9137 86.804 84.9137 84.7875C84.9137 83.023 84.1323 81.5863 82.5695 80.4772C81.0067 79.3177 78.5113 78.5615 75.0832 78.2086L71.2266 77.9061C65.8324 77.402 61.5473 75.7888 58.3713 73.0665C55.1953 70.2938 53.6073 66.3868 53.6073 61.3455C53.6073 57.867 54.3887 54.9682 55.9515 52.6492C57.5143 50.2798 59.7577 48.5154 62.6816 47.3559C65.6056 46.146 69.1093 45.541 73.1927 45.541C77.5787 45.541 81.2588 46.2216 84.2332 47.5827C87.2075 48.9439 89.4509 50.91 90.9633 53.481C92.5261 56.0521 93.3075 59.1777 93.3075 62.8578H82.1914C82.1914 61.3959 81.8386 60.1103 81.1328 59.0013C80.4774 57.8418 79.4944 56.9091 78.1836 56.2033C76.8729 55.4976 75.2093 55.1447 73.1927 55.1447C71.4283 55.1447 69.9159 55.3967 68.6556 55.9009C67.3952 56.405 66.4374 57.136 65.782 58.0938C65.1267 59.0013 64.799 60.0851 64.799 61.3455C64.799 62.9083 65.3787 64.3198 66.5382 65.5801C67.6977 66.7901 69.6134 67.5463 72.2853 67.8487L76.1419 68.1512C82.1914 68.6553 87.0311 70.2938 90.6608 73.0665C94.2905 75.8392 96.1054 79.7462 96.1054 84.7875C96.1054 88.266 95.2484 91.2151 93.5344 93.6349C91.8203 96.0548 89.3249 97.8948 86.048 99.1552C82.8216 100.415 78.8894 101.046 74.2514 101.046ZM68.8824 110.498V99.4576H78.7886V110.498H68.8824ZM68.58 49.2464V38.2059H78.4861V49.2464H68.58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.29e86e41d7a7b9bc81d07442e5261ae2.svg";
export { ForwardRef as ReactComponent };